<div class="sgt-cliente-analise-mercado-rap-table"
    [class.edit-mode]="revisaoMode"
    #container
    cdk-scrollable
    infiniteScroll
    [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="1000"
    [scrollWindow]="false" 
    (scrolled)="onInfiniteScroll.emit()">

    <table class="table table-striped table-hover table-bordered" [id]="idDataTable">
        <thead>
            <tr class="first-row">
                <th class="col-options text-center row-span-2" rowspan="2"></th>
                <th class="col-nome-cliente row-span-2" rowspan="2">Cliente</th>

                <ng-template [ngIf]="revisaoMode">
                    <th class="col-rar-ano-anterior text-right row-span-2" rowspan="2" title="{{KPI_RAR.nome}} {{legenda?.anoAnterior2}}">{{KPI_RAR.sigla}} {{legenda?.anoAnterior2}}</th>
                    <th class="col-rar-ano-anterior text-right row-span-2" rowspan="2" title="{{KPI_RAR.nome}} {{legenda?.anoAnterior1}}">{{KPI_RAR.sigla}} {{legenda?.anoAnterior1}}</th>
                    <th class="col-rap-ano-anterior text-right row-span-2" rowspan="2" title="{{KPI_RAR.nome}} {{legenda?.anoAnterior1}}">{{KPI_RAP.sigla}} {{legenda?.anoAnterior1}}</th>
                </ng-template>

                <th class="col-sell-in-cliente text-right row-span-2" rowspan="2" title="{{KPI_SELL_IN_CLIENTE.nome}}">{{KPI_SELL_IN_CLIENTE.nome}}</th>
                <th class="col-customer-share-rap text-center" colspan="3" title="{{KPI_CUSTOMER_SHARE.nome}} da {{KPI_RAP.nome}}">{{KPI_CUSTOMER_SHARE.nome}} {{KPI_RAP.sigla}}</th>
                <th class="col-customer-share-rar text-center" colspan="3" title="{{KPI_CUSTOMER_SHARE.nome}} da {{KPI_RAR.nome}}">{{KPI_CUSTOMER_SHARE.nome}} {{KPI_RAR.sigla}}</th>
            </tr>
            <tr class="second-row">
                <!-- Customer Share RAP -->
                <th class="col-customer-share-rap-perc text-right" title="Percentual de {{KPI_CUSTOMER_SHARE.nome}} {{KPI_RAP.sigla}} %">Perc. %</th>
                <th class="col-customer-share-rap-valor text-right" title="Valor de {{KPI_CUSTOMER_SHARE.nome}} {{KPI_RAP.sigla}} %">Valor R$</th>
                <th class="col-nome-classificacao-rap" title="Classificação {{KPI_RAP.nome}}">Classificação</th>
                
                <!-- Customer Share RAR -->
                <th class="col-customer-share-rar-perc text-right" title="Percentual de {{KPI_CUSTOMER_SHARE.nome}} {{KPI_RAR.sigla}} %">Perc. %</th>
                <th class="col-customer-share-rar-valor text-right" title="Valor de {{KPI_CUSTOMER_SHARE.nome}} {{KPI_RAR.sigla}} %">Valor R$</th>
                <th class="col-nome-classificacao-rar" title="Classificação {{KPI_RAR.nome}}">Classificação</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let cliente of clientes; let index = index">
                <td class="col-options text-center">
                    <span class="btn-group dropup table-options" sgtDropdownContainerBody *ngIf="cliente.options">
                        <button type="button" title="Opções" class="btn btn-link btn-options dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" tabindex="-1">
                            <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                        </button>
                        <div class="dropdown-menu">
                            <ng-template [ngIf]="cliente.options.hasOptionsAnaliseMercado()">
                                <h6 class="dropdown-header">Análise de Mercado</h6>
                                <a class="dropdown-item" *ngIf="cliente.options.canOpenAnaliseMercado" (click)="openAnaliseMercado.emit(cliente)">
                                    Abrir Análise
                                </a>                                                                          
                            </ng-template>
                            
                            <ng-template [ngIf]="cliente.options.hasOptionsCliente()">
                                <div class="dropdown-divider"></div>
                                <h6 class="dropdown-header">Cliente</h6>
                                <a class="dropdown-item" *ngIf="cliente.options.canOpenCliente" (click)="openCliente.emit(cliente)">
                                    Abrir Cadastro
                                </a>      
                                <a class="dropdown-item dropdown-item-prebaixar" *ngIf="cliente.options.canPreBaixarCliente" (click)="preBaixarCliente.emit(cliente)">
                                    Pré-Baixar Cliente
                                </a>   
                                <a class="dropdown-item dropdown-item-baixar" *ngIf="cliente.options.canBaixarCliente" (click)="baixarCliente.emit(cliente)">
                                    Baixar Cliente
                                </a>                                                                                       
                            </ng-template>
    
                            <ng-template [ngIf]="cliente.options.hasOptionsCentralCompra()">
                                <div class="dropdown-divider"></div>
                                <h6 class="dropdown-header">Central de Compras</h6>
                                <a class="dropdown-item" *ngIf="cliente.options.canInsertCentralCompra" (click)="insertCentralCompra.emit()">
                                    Adicionar Central de Compras
                                </a>   
                                <a class="dropdown-item" *ngIf="cliente.options.canEditCentralCompra" (click)="editCentralCompra.emit(cliente)">
                                    Atualizar Central de Compras
                                </a>  
                                <a class="dropdown-item" *ngIf="cliente.options.canInsertParticipanteCentralCompra" (click)="insertParticipanteCentralCompra.emit(cliente)">
                                    Adicionar Como Participante
                                </a>                                                                                           
                            </ng-template>
                        </div>
                    </span>
                </td>
                <td class="col-nome-cliente">
                    <span class="col-nome-cliente-group-nomes">
                        {{cliente.nomeCliente | clienteNome: cliente.nomeFantasiaCliente:cliente.codigoIntegracaoErpCliente:cliente.tipoPessoa}}
                        <small>{{cliente.nomeCliente | clienteNomeSecundario: cliente.nomeFantasiaCliente}}</small>

                        <ng-template [ngIf]="revisaoMode">
                            <small class="periodicidade-warning" title="Abra a Análise para poder alterar seus valores" *ngIf="cliente.isPeriodicidadeMediaMensal">
                                <i class="fas fa-exclamation-triangle"></i> Lançamento pela Média Mensal
                            </small>
                            <small class="periodicidade-warning" title="Abra a Análise para poder alterar seus valores" *ngIf="cliente.isPeriodicidadeMensal">
                                <i class="fas fa-exclamation-triangle"></i> Lançamento Mensal
                            </small>                            
                        </ng-template>
                    </span>
                    <span class="col-nome-cliente-group-badges">
                        <span class="{{cliente.cadastro | clienteCadastroBadge}}" title="{{cliente.cadastro | clienteCadastro}}">{{cliente.cadastro | clienteCadastro}}</span>
                        <span class="{{cliente.situacao | clienteSituacaoBadge}}" title="{{cliente.situacao | clienteSituacao}}">{{cliente.situacao | clienteSituacao}}</span>
                    </span>
                </td>   
                
                <ng-template [ngIf]="revisaoMode">
                    <!-- RAR Ano Anterior 2 -->
                    <td class="col-rar-ano-anterior text-right">
                        {{cliente.valorRealizadoAnoAnterior2 | currencyFormat: 1:0:0}}
                    </td>
    
                    <!-- RAR Ano Anterior 1 -->
                    <td class="col-rar-ano-anterior text-right">
                        {{cliente.valorRealizadoAnoAnterior1 | currencyFormat: 1:0:0}}
                    </td>
                    
                    <!-- RAP Ano Anterior 1 -->
                    <td class="col-rap-ano-anterior text-right">
                        {{cliente.valorPretendidoAnoAnterior1 | currencyFormat: 1:0:0}}
                    </td>                
                </ng-template>                
                
    
                <!-- Sell In Cliente -->            
                <td class="col-sell-in-cliente text-right">
                    <ng-template [ngIf]="revisaoMode">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    R$
                                </span>
                            </div>
                            <sgt-decimal2 [(ngModel)]="cliente.valorPotencial" name="valorPotencial_{{index}}" id="valorPotencial_{{index}}"
                                #valorPotencial="ngModel" [ngControl]="valorPotencial" [digits]="0" [disabled]="!cliente.canEditLancamento"
                                (ngModelChange)="onChangeSellInCliente(cliente)"
                                sgtTableTrActive>
                            </sgt-decimal2> 
                        </div>                        
                    </ng-template>

                    <ng-template [ngIf]="!revisaoMode">
                        {{cliente.valorPotencial | currencyFormat: 1:0:0}}
                    </ng-template>            
                </td>

                <!-- Customer Share RAP -->
                <td class="col-customer-share-rap-perc text-right">
                    <ng-template [ngIf]="revisaoMode">
                        <div class="input-group">
                            <sgt-decimal2 [(ngModel)]="cliente.customerShareRAP" name="customerShareRAP_{{index}}" id="customerShareRAP_{{index}}"
                                #customerShareRAP="ngModel" [ngControl]="customerShareRAP" [digits]="0" [disabled]="!cliente.canEditLancamento"
                                (ngModelChange)="onChangeCustomerShareRAP(cliente)"
                                sgtTableTrActive>
                            </sgt-decimal2> 

                            <div class="input-group-append">
                                <span class="input-group-text">
                                    %
                                </span>
                                <span class="input-group-text input-group-text-indicador-badge">
                                    <sgt-customer-share-indicador-badge
                                        [indicador]="cliente.indicadorCustomerShareRAP"
                                        fontSize="8px">
                                    </sgt-customer-share-indicador-badge>   
                                </span>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template [ngIf]="!revisaoMode">
                        <sgt-customer-share-indicador-badge
                            [indicador]="cliente.indicadorCustomerShareRAP"
                            [perc]="cliente.customerShareRAP"
                            [percMinIntegerDigits]="1"
                            [percMinFractionDigits]="0"
                            [percMaxFractionDigits]="0"
                            fontSize="8px">
                        </sgt-customer-share-indicador-badge>                    
                    </ng-template>                    
                </td>
                <td class="col-customer-share-rap-valor text-right">
                    <ng-template [ngIf]="revisaoMode">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    R$
                                </span>
                            </div>
                            <sgt-decimal2 [(ngModel)]="cliente.valorPretendido" name="valorPretendido_{{index}}" id="valorPretendido_{{index}}"
                                #valorPretendido="ngModel" [ngControl]="valorPretendido" [digits]="0" [disabled]="!cliente.canEditLancamento"
                                (ngModelChange)="onChangeCustomerShareValorRAP(cliente)"
                                sgtTableTrActive>
                            </sgt-decimal2>                            
                        </div>                        
                    </ng-template>

                    <ng-template [ngIf]="!revisaoMode">
                        {{cliente.valorPretendido | currencyFormat: 1:0:0}}
                    </ng-template>                    
                </td>
                <td class="col-nome-classificacao-rap" [title]="cliente.nomeClassificacaoRAP ? cliente.nomeClassificacaoRAP : ''">
                    {{cliente.nomeClassificacaoRAP}}
                </td>                 

                <!-- Customer Share RAR -->
                <td class="col-customer-share-rar-perc text-right">
                    <sgt-customer-share-indicador-badge
                        [indicador]="cliente.indicadorCustomerShareRAR"
                        [perc]="cliente.customerShareRAR"
                        [percMinIntegerDigits]="1"
                        [percMinFractionDigits]="0"
                        [percMaxFractionDigits]="0"
                        fontSize="8px">
                    </sgt-customer-share-indicador-badge>
                </td>
                <td class="col-customer-share-rar-valor text-right">
                    {{cliente.valorRealizado | currencyFormat: 1:0:0}}
                </td>   
                <td class="col-nome-classificacao-rar" [title]="cliente.nomeClassificacaoRAR ? cliente.nomeClassificacaoRAR : ''">
                    {{cliente.nomeClassificacaoRAR}}
                </td>                              
            </tr>
            <tr *ngIf="isEmpty">
                <td class="text-center" colspan="100">
                    <i class='fas fa-info' aria-hidden='true'></i> Nenhum Cliente Encontrado
                </td>
            </tr> 
            <!-- <tr *ngIf="isUltimaPagina">
                <td class="text-center" colspan="100">
                    <i class="fas fa-check"></i> Fim da Consulta
                </td>
            </tr>            -->
        </tbody>        
        <tfoot>
            <tr>
                <td colspan="2" class="col-quantidade-clientes text-center">
                    {{total?.quantidadeClientes | decimalFormat: 1:0:0:true}} cliente(s)
                </td>

                <ng-template [ngIf]="revisaoMode">
                    <!-- RAR Ano Anterior 2 -->
                    <td class="col-rar-ano-anterior text-right">
                        {{total?.valorRealizadoAnoAnterior2 | currencyFormat: 1:0:0}}
                    </td>
    
                    <!-- RAR Ano Anterior 1 -->
                    <td class="col-rar-ano-anterior text-right">
                        {{total?.valorRealizadoAnoAnterior1 | currencyFormat: 1:0:0}}
                    </td>
                    
                    <!-- RAP Ano Anterior 1 -->
                    <td class="col-rap-ano-anterior text-right">
                        {{total?.valorPretendidoAnoAnterior1 | currencyFormat: 1:0:0}}
                    </td>  
                </ng-template>                

                <!-- Sell In Cliente -->
                <td class="col-sell-in-cliente text-right">
                    {{total?.valorPotencial | currencyFormat: 1:0:0:true}}
                </td>
    
                <!-- Customer Share RAP -->
                <td class="col-customer-share-rap-perc text-right">
                    <sgt-customer-share-indicador-badge
                        [indicador]="total?.indicadorCustomerShareRAP"
                        [perc]="total?.customerShareRAP"
                        [percMinIntegerDigits]="1"
                        [percMinFractionDigits]="0"
                        [percMaxFractionDigits]="0"
                        fontSize="8px">
                    </sgt-customer-share-indicador-badge>
                </td>  
                <td class="col-customer-share-rap-valor text-right">
                    {{total?.valorPretendido | currencyFormat: 1:0:0:true}}
                </td>
                <td class="col-nome-classificacao-rap"></td>
                
                <!-- Customer Share RAR -->
                <td class="col-customer-share-rar-perc text-right">
                    <sgt-customer-share-indicador-badge
                        [indicador]="total?.indicadorCustomerShareRAR"
                        [perc]="total?.customerShareRAR"
                        [percMinIntegerDigits]="1"
                        [percMinFractionDigits]="0"
                        [percMaxFractionDigits]="0"
                        fontSize="8px">
                    </sgt-customer-share-indicador-badge>
                </td>   
                <td class="col-customer-share-rar-valor text-right">
                    {{total?.valorRealizado | currencyFormat: 1:0:0:true}}
                </td>
                <td class="col-nome-classificacao-rar"></td>
            </tr>
        </tfoot>
    </table>    
</div>